(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lh-gg-editorial-split"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Slow-scale image on load
  document.querySelectorAll('.lh-gg-ed__img').forEach(function(img) {
    if (img.complete) {
      img.classList.add('is-loaded');
    } else {
      img.addEventListener('load', function() { img.classList.add('is-loaded'); });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-gg-filters"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initFilters(wrapper) {
    var tabs    = wrapper.querySelectorAll('[data-filter]');
    var current = 'all';

    /* ── sentinel: 1px div always in flow, marks the bar's position ─ */
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;visibility:hidden;pointer-events:none;flex-shrink:0;';
    wrapper.parentNode.insertBefore(sentinel, wrapper);

    /* ── spacer: holds layout height when bar goes position:fixed ─── */
    var spacer = document.createElement('div');
    spacer.className = 'lh-gg-filters__spacer';
    spacer.style.height = wrapper.offsetHeight + 'px';
    wrapper.parentNode.insertBefore(spacer, wrapper.nextSibling);

    /* ── dynamically track the header's actual visible bottom ────── */
    var header = document.querySelector('[data-custom-header]');
    function getHeaderOffset() {
      if (!header) return 0;
      var rect = header.getBoundingClientRect();
      return rect.bottom > 0 ? rect.bottom : 0;
    }
    function updateFilterTop() {
      wrapper.style.setProperty('--lh-filter-top', getHeaderOffset() + 'px');
    }

    /* ── stick/unstick: move to <body> when fixed so z-index is root */
    var originalParent = sentinel.parentNode;
    var inBody = false;

    function checkStuck() {
      var sentinelTop = sentinel.getBoundingClientRect().top;
      var threshold = getHeaderOffset();
      var shouldStick = sentinelTop <= threshold;

      if (shouldStick && !inBody) {
        updateFilterTop();
        wrapper.classList.add('is-stuck');
        spacer.classList.add('is-active');
        document.body.appendChild(wrapper); /* move to root — escapes all stacking contexts */
        inBody = true;
      } else if (!shouldStick && inBody) {
        originalParent.insertBefore(wrapper, spacer); /* restore before spacer */
        wrapper.classList.remove('is-stuck');
        spacer.classList.remove('is-active');
        inBody = false;
      } else if (shouldStick) {
        updateFilterTop();
      }
    }
    checkStuck();
    window.addEventListener('scroll', checkStuck, { passive: true });
    window.addEventListener('resize', function() {
      spacer.style.height = wrapper.offsetHeight + 'px';
      checkStuck();
    }, { passive: true });

    /* ── gather filterable sections ──────────────── */
    function getFilterable() {
      return document.querySelectorAll('.lh-gg-section[data-gg-filter]');
    }

    /* ── apply filter ────────────────────────────── */
    function applyFilter(key) {
      current = key;
      var anchor = wrapper.querySelector('[data-filter="' + key + '"]');
      var anchorId = anchor ? anchor.getAttribute('data-anchor') : '';

      getFilterable().forEach(function(sec) {
        var tags = (sec.getAttribute('data-gg-filter') || '').split(' ').filter(Boolean);
        /* sections with no category-specific tag (only "all") are always visible —
           they're universal brand content that sits between category sections */
        var hasCategory = tags.some(function(t) { return t !== 'all'; });
        var isUniversal = !hasCategory;
        if (key === 'all' || tags.indexOf(key) !== -1 || isUniversal) {
          sec.removeAttribute('data-gg-hidden');
        } else {
          sec.setAttribute('data-gg-hidden', '');
        }
      });

      /* re-register fade-up elements so they animate in after being un-hidden */
      if (window.__lhGgFadeObserver) {
        getFilterable().forEach(function(sec) {
          if (!sec.hasAttribute('data-gg-hidden')) {
            sec.querySelectorAll('.lh-gg-fade-up:not(.is-visible)').forEach(function(el) {
              window.__lhGgFadeObserver.unobserve(el);
              window.__lhGgFadeObserver.observe(el);
            });
          }
        });
      }

      /* scroll to anchor — defer one frame so layout settles after display:none changes;
         offset = header bottom + filter bar height so the section appears below both */
      if (anchorId) {
        requestAnimationFrame(function() {
          var target = document.getElementById(anchorId);
          if (!target) return;
          var headerH = getHeaderOffset();
          var filterH = wrapper.getBoundingClientRect().height;
          var top = target.getBoundingClientRect().top + window.scrollY - headerH - filterH - 8;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
      }
    }

    /* ── set active tab ──────────────────────────── */
    function setActive(key) {
      tabs.forEach(function(t) {
        var active = t.getAttribute('data-filter') === key;
        t.classList.toggle('is-active', active);
        if (active) {
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      });
    }

    /* ── tab click (delegated so it always fires) ── */
    wrapper.addEventListener('click', function(e) {
      var tab = e.target.closest('[data-filter]');
      if (!tab) return;
      var key = tab.getAttribute('data-filter');
      setActive(key);
      applyFilter(key);
    });

    /* ── auto-highlight on scroll ────────────────── */
    var scrollObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        var sec = entry.target;
        var tags = (sec.getAttribute('data-gg-filter') || '').split(' ');
        /* find most specific matching tab */
        var best = null;
        tabs.forEach(function(t) {
          var k = t.getAttribute('data-filter');
          if (k !== 'all' && tags.indexOf(k) !== -1) best = k;
        });
        setActive(best || 'all');
      });
    }, { threshold: 0.35 });

    getFilterable().forEach(function(sec) { scrollObs.observe(sec); });
  }

  /* ── init on load + theme editor section:load ── */
  function init() {
    document.querySelectorAll('[data-gg-filters]').forEach(initFilters);
  }
  init();
  document.addEventListener('shopify:section:load', init);

  /* ── fade-up observer — fallback init so it always runs even when
     lh-gg-intro is disabled/hidden in the customizer ──────────── */
  function initFadeObserver() {
    if (window.__lhGgFadeObserver) return;
    window.__lhGgFadeObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            window.__lhGgFadeObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    function observeAll() {
      document.querySelectorAll('.lh-gg-fade-up:not(.is-visible)').forEach(function (el) {
        window.__lhGgFadeObserver.observe(el);
      });
    }
    observeAll();
    document.addEventListener('shopify:section:load', observeAll);
  }
  initFadeObserver();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-gg-gift-card-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGiftCardSection(sectionEl) {
    var btns = sectionEl.querySelectorAll('.lh-gg-gc__amount-btn[data-variant-id]');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cardId         = btn.getAttribute('data-card-id');
        var amountId       = btn.getAttribute('data-amount-id');
        var variantInputId = btn.getAttribute('data-variant-input');
        var panelId        = btn.getAttribute('data-panel-id');
        var amount         = btn.getAttribute('data-amount');
        var variantId      = btn.getAttribute('data-variant-id');

        var card         = document.getElementById(cardId);
        var display      = document.getElementById(amountId);
        var variantInput = variantInputId ? document.getElementById(variantInputId) : null;
        var panel        = panelId ? document.getElementById(panelId) : null;

        // Update active button state
        btns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        // Update hidden variant input
        if (variantInput && variantId) {
          variantInput.value = variantId;
        }

        // Tilt card animation
        if (card) {
          card.classList.add('is-tilting');
          setTimeout(function () { card.classList.remove('is-tilting'); }, 620);
        }

        // Swap amount display
        if (display) {
          display.classList.add('is-changing');
          setTimeout(function () {
            display.textContent = amount;
            display.classList.remove('is-changing');
          }, 200);
        }

        // Open panel (stays open once opened)
        if (panel && !panel.classList.contains('is-open')) {
          panel.classList.add('is-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          panel.setAttribute('aria-hidden', 'false');
          // After transition, allow natural height (handles dynamic content)
          panel.addEventListener('transitionend', function onEnd() {
            panel.style.maxHeight = 'none';
            panel.removeEventListener('transitionend', onEnd);
          });
        }
      });
    });

    // Redirect to cart on submit (bypasses theme's AJAX cart drawer)
    var form = sectionEl.querySelector('.lh-gg-gc__form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var submitBtn = form.querySelector('[name="add"]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Adding…';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form)
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Add to Bag';
            }
          });
      });
      // Store original label for error recovery
      var submitBtn = form.querySelector('[name="add"]');
      if (submitBtn) submitBtn.setAttribute('data-label', submitBtn.textContent.trim());
    }

    // Character counter
    var textarea = sectionEl.querySelector('.lh-gg-gc__textarea');
    if (textarea) {
      var counterId = textarea.getAttribute('data-char-counter');
      var counterEl = counterId ? document.getElementById(counterId) : null;
      if (counterEl) {
        textarea.addEventListener('input', function () {
          counterEl.textContent = this.value.length;
        });
      }
    }

    // Date: set minimum to today
    var dateInput = sectionEl.querySelector('.lh-gg-gc__input--date');
    if (dateInput) {
      dateInput.min = new Date().toISOString().split('T')[0];
    }
  }

  function init() {
    document.querySelectorAll('.lh-gg-gc').forEach(initGiftCardSection);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initGiftCardSection(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-gg-intro"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Shared fade-up observer — guard so it only registers once per page
  if (window.__lhGgFadeObserver) return;

  window.__lhGgFadeObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          window.__lhGgFadeObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12 }
  );

  function observeAll() {
    document.querySelectorAll('.lh-gg-fade-up:not(.is-visible)').forEach(function (el) {
      window.__lhGgFadeObserver.observe(el);
    });
  }

  // Run now + watch for dynamically added sections (theme editor)
  observeAll();
  document.addEventListener('shopify:section:load', observeAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-gg-starchart"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ── Zodiac data ─────────────────────────────────────────── */
  var ZODIAC = [
    { name:'Capricorn',   start:[12,22], end:[1,19]  },
    { name:'Aquarius',    start:[1,20],  end:[2,18]  },
    { name:'Pisces',      start:[2,19],  end:[3,20]  },
    { name:'Aries',       start:[3,21],  end:[4,19]  },
    { name:'Taurus',      start:[4,20],  end:[5,20]  },
    { name:'Gemini',      start:[5,21],  end:[6,20]  },
    { name:'Cancer',      start:[6,21],  end:[7,22]  },
    { name:'Leo',         start:[7,23],  end:[8,22]  },
    { name:'Virgo',       start:[8,23],  end:[9,22]  },
    { name:'Libra',       start:[9,23],  end:[10,22] },
    { name:'Scorpio',     start:[10,23], end:[11,21] },
    { name:'Sagittarius', start:[11,22], end:[12,21] }
  ];

  var BIRTHSTONES = ['Garnet','Amethyst','Aquamarine','Diamond','Emerald','Pearl','Ruby','Peridot','Sapphire','Opal','Topaz','Tanzanite'];

  var LP_NAMES = {
    1:'The Leader', 2:'The Peacemaker', 3:'The Creator',
    4:'The Builder', 5:'The Adventurer', 6:'The Nurturer',
    7:'The Seeker', 8:'The Powerhouse', 9:'The Humanitarian',
    11:'The Visionary', 22:'The Master Builder', 33:'The Master Teacher'
  };

  function getZodiac(m, d) {
    for (var i = 0; i < ZODIAC.length; i++) {
      var z = ZODIAC[i];
      var s = z.start, e = z.end;
      if (s[0] === e[0]) {
        if (m === s[0] && d >= s[1] && d <= e[1]) return z.name;
      } else {
        if ((m === s[0] && d >= s[1]) || (m === e[0] && d <= e[1])) return z.name;
      }
    }
    return 'Capricorn';
  }

  function getLifePath(m, d, y) {
    var digits = ('' + m + d + y).split('').map(Number);
    var sum = digits.reduce(function(a, b) { return a + b; }, 0);
    while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
      sum = ('' + sum).split('').map(Number).reduce(function(a, b) { return a + b; }, 0);
    }
    return sum;
  }

  /* ── Shareable URL helpers ──
     Uses ?cosmic= query param (not hash) — query params survive HTTP redirects
     from myshopify.com → custom domain. Hashes are stripped during that redirect.
     The displayed URL is always the clean canonical path, no preview params. ── */
  var _pad = function(n) { return n < 10 ? '0' + n : '' + n; };

  function encodeCosmicParam(m, d, y) {
    return _pad(m) + '-' + _pad(d) + '-' + y;
  }

  function setCosmicParam(m, d, y) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('cosmic', encodeCosmicParam(m, d, y));
      history.replaceState(null, '', url.toString());
    } catch(e) {}
  }

  function clearCosmicParam() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('cosmic');
      history.replaceState(null, '', url.toString());
    } catch(e) {}
  }

  function buildShareUrl(m, d, y) {
    /* Canonical URL — hostname + pathname only, strips preview/dev params */
    return window.location.protocol + '//' + window.location.hostname
      + window.location.pathname + '?cosmic=' + encodeCosmicParam(m, d, y);
  }

  function decodeCosmicParam() {
    try {
      var val = new URLSearchParams(window.location.search).get('cosmic');
      if (!val) return null;
      var match = val.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
      if (!match) return null;
      return { m: parseInt(match[1], 10), d: parseInt(match[2], 10), y: parseInt(match[3], 10) };
    } catch(e) { return null; }
  }

  /* ── Init each starchart form on the page ─────────────────── */
  document.querySelectorAll('[id^="lh-gg-sc-form-"]').forEach(function(form) {
    var sid     = form.id.replace('lh-gg-sc-form-', '');
    var result  = document.getElementById('lh-gg-sc-result-' + sid);
    var dataEl  = document.getElementById('lh-gg-sc-data-' + sid);
    if (!result || !dataEl) return;

    var blockData = {};
    try { blockData = JSON.parse(dataEl.textContent); } catch(e) {}
    var signs = blockData.signs || [];
    var isRecipient = false;

    var loading   = document.getElementById('lh-gg-sc-loading-' + sid);
    var phraseEl  = loading ? loading.querySelector('[data-sc-loading-phrase]') : null;
    var submitBtn = form.querySelector('[type="submit"]');
    var PHRASES   = [
      'Reading the stars\u2026',
      'Calculating your life path\u2026',
      'Finding your cosmic match\u2026'
    ];

    /* Cycle loading phrases with a fade transition */
    function setPhrase(text) {
      if (!phraseEl) return;
      phraseEl.classList.add('is-fading');
      setTimeout(function() {
        phraseEl.textContent = text;
        phraseEl.classList.remove('is-fading');
      }, 300);
    }

    /* Populate all pick cards */
    function populatePicks(signData) {
      if (!signData || !signData.picks) return;
      signData.picks.forEach(function(pick, i) {
        var n           = i + 1;
        var nameEl      = result.querySelector('[data-sc-pick-name="'       + n + '"]');
        var whyEl       = result.querySelector('[data-sc-pick-why="'        + n + '"]');
        var priceEl     = result.querySelector('[data-sc-pick-price="'      + n + '"]');
        var linkEl      = result.querySelector('[data-sc-pick-link="'       + n + '"]');
        var mediaLinkEl = result.querySelector('[data-sc-pick-media-link="' + n + '"]');
        var mediaEl     = result.querySelector('[data-sc-pick-media="'      + n + '"]');
        var imgEl       = result.querySelector('[data-sc-pick-img="'        + n + '"]');
        var imgAltEl    = result.querySelector('[data-sc-pick-img-alt="'    + n + '"]');
        var glyphEl     = result.querySelector('[data-sc-pick-glyph="'      + n + '"]');
        var wishEl      = result.querySelector('[data-sc-wish="'            + n + '"]');

        if (nameEl)  nameEl.textContent  = pick.name  || '';
        if (whyEl)   whyEl.textContent   = pick.why   || '';
        if (priceEl) priceEl.textContent = pick.price || '';

        var url = pick.url || '#';
        if (linkEl)      linkEl.href      = url;
        if (mediaLinkEl) { mediaLinkEl.href = url; mediaLinkEl.setAttribute('aria-label', pick.name || ''); }

        if (imgEl) {
          if (pick.img) {
            imgEl.src    = pick.img;
            imgEl.alt    = pick.name || '';
            imgEl.hidden = false;
            if (glyphEl) glyphEl.style.display = 'none';
          } else {
            imgEl.hidden = true;
            if (glyphEl) glyphEl.style.display = '';
          }
        }
        if (imgAltEl && mediaEl) {
          if (pick.img_alt) {
            imgAltEl.src    = pick.img_alt;
            imgAltEl.alt    = pick.name || '';
            imgAltEl.hidden = false;
            mediaEl.classList.add('lh-gg-sc__pick-media--has-alt');
          } else {
            imgAltEl.hidden = true;
            mediaEl.classList.remove('lh-gg-sc__pick-media--has-alt');
          }
        }

        if (wishEl) {
          if (pick.product_id) {
            wishEl.setAttribute('data-product-id',  pick.product_id);
            wishEl.setAttribute('data-variant-id',  pick.variant_id);
            wishEl.setAttribute('data-product-url', pick.product_url || '#');
            wishEl.setAttribute('data-swaction',    'addToWishlist');
            wishEl.classList.add('swym-button', 'swym-add-to-wishlist', 'product_' + pick.product_id);
            wishEl.setAttribute('aria-label', 'Add ' + (pick.name || '') + ' to wishlist');
            wishEl.hidden = false;
          } else {
            wishEl.hidden = true;
          }
        }
      });
    }

    /* ── Year field: numeric-only, max 4 chars ── */
    var yearInput = form.querySelector('[data-sc-year]');
    if (yearInput) {
      yearInput.addEventListener('input', function() {
        var v = this.value.replace(/[^0-9]/g, '');
        if (v.length > 4) v = v.slice(0, 4);
        this.value = v;
      });
      yearInput.addEventListener('keydown', function(e) {
        var allowed = ['Backspace','Delete','Tab','Escape','Enter','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End'];
        if (allowed.indexOf(e.key) !== -1) return;
        if (e.key >= '0' && e.key <= '9' && this.value.length < 4) return;
        e.preventDefault();
      });
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var m = parseInt(form.querySelector('[data-sc-month]').value, 10);
      var d = parseInt(form.querySelector('[data-sc-day]').value, 10);
      var y = parseInt(form.querySelector('[data-sc-year]').value, 10);
      if (!m || !d || !y || y < 1900 || y > 2025) return;

      var zodiacName = getZodiac(m, d);
      var lp         = getLifePath(m, d, y);
      var stone      = BIRTHSTONES[m - 1];
      var lpName     = LP_NAMES[lp] || 'The Cosmic One';

      /* ── Encode birthday in URL for shareability ── */
      setCosmicParam(m, d, y);

      /* ── Show loading ── */
      if (loading) loading.hidden = false;
      if (submitBtn) submitBtn.disabled = true;
      if (phraseEl) phraseEl.textContent = PHRASES[0];
      var t1 = setTimeout(function() { setPhrase(PHRASES[1]); }, 550);
      var t2 = setTimeout(function() { setPhrase(PHRASES[2]); }, 1050);

      /* ── After dramatic pause, reveal results ── */
      setTimeout(function() {
        clearTimeout(t1); clearTimeout(t2);
        if (loading) loading.hidden = true;
        if (submitBtn) submitBtn.disabled = false;

        /* Profile strip */
        result.querySelector('[data-sc-zodiac-glyph]').textContent = zodiacName;
        result.querySelector('[data-sc-zodiac-energy]').textContent = stone + ' Energy';
        result.querySelector('[data-sc-lp-glyph]').textContent      = lp;
        result.querySelector('[data-sc-lp-name]').textContent       = lpName;
        result.querySelector('[data-sc-stone-name]').textContent    = stone;

        var signData = signs.find(function(s) {
          return s.sign && s.sign.toLowerCase() === zodiacName.toLowerCase();
        }) || signs[0];
        populatePicks(signData);

        result.hidden = false;
        requestAnimationFrame(function() {
          result.classList.add('is-visible');
          if (window._swat && typeof window._swat.initializePlugin === 'function') {
            window._swat.initializePlugin();
          } else if (window.SwymCallbacks) {
            window.SwymCallbacks.push(function(swat) { swat.initializePlugin(); });
          }
          var filterBar = document.querySelector('[data-gg-filters]');
          var top = result.getBoundingClientRect().top + window.scrollY
                    - (filterBar ? filterBar.getBoundingClientRect().height : 0) - 24;
          window.scrollTo({ top: top, behavior: 'smooth' });

          /* Reveal recipient banner or share panel after cards finish entering */
          setTimeout(function() {
            if (isRecipient) {
              var bannerEl = result.querySelector('[data-sc-recipient-banner]');
              if (bannerEl) {
                bannerEl.hidden = false;
                requestAnimationFrame(function() { bannerEl.classList.add('is-visible'); });
              }
            } else {
              var shareEl    = result.querySelector('[data-sc-share]');
              var shareUrlEl = result.querySelector('[data-sc-share-url]');
              if (shareEl && shareUrlEl) {
                var shareUrl = buildShareUrl(m, d, y);
                shareUrlEl.textContent = shareUrl;
                var msg = 'Here’s what the cosmos thinks you should get me. ' + shareUrl;
                var smsEl   = shareEl.querySelector('[data-sc-send-sms]');
                var emailEl = shareEl.querySelector('[data-sc-send-email]');
                if (smsEl)   smsEl.href   = 'sms:?&body=' + encodeURIComponent(msg);
                if (emailEl) emailEl.href = 'mailto:?subject=' + encodeURIComponent('My cosmic gift picks') + '&body=' + encodeURIComponent(msg);
                shareEl.hidden = false;
                requestAnimationFrame(function() { shareEl.classList.add('is-visible'); });
              }
            }
          }, 700);
        });
      }, 1500);
    });

    /* ── Reset: "Try another birthday" ── */
    result.addEventListener('click', function(e) {
      if (!e.target.closest('[data-sc-reset]')) return;

      /* Collapse share panel */
      var shareEl = result.querySelector('[data-sc-share]');
      if (shareEl) {
        shareEl.classList.remove('is-visible');
        setTimeout(function() { shareEl.hidden = true; }, 350);
      }

      /* Collapse recipient banner */
      var bannerEl = result.querySelector('[data-sc-recipient-banner]');
      if (bannerEl) {
        bannerEl.classList.remove('is-visible');
        setTimeout(function() { bannerEl.hidden = true; }, 350);
      }
      isRecipient = false;

      result.classList.remove('is-visible');
      clearCosmicParam();
      setTimeout(function() {
        result.hidden = true;
        form.querySelector('[data-sc-month]').value = '';
        form.querySelector('[data-sc-day]').value   = '';
        form.querySelector('[data-sc-year]').value  = '';
      }, 450);
      var formTop = form.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: formTop, behavior: 'smooth' });
    });

    /* ── Copy link ── */
    result.addEventListener('click', function(e) {
      var copyBtn = e.target.closest('[data-sc-copy]');
      if (!copyBtn) return;
      var url = result.querySelector('[data-sc-share-url]').textContent || window.location.href;
      function onCopied() {
        copyBtn.textContent = 'Copied \u2713';
        copyBtn.classList.add('is-copied');
        setTimeout(function() {
          copyBtn.textContent = 'Copy Link';
          copyBtn.classList.remove('is-copied');
        }, 2500);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(onCopied).catch(function() {
          fallbackCopy(url); onCopied();
        });
      } else {
        fallbackCopy(url); onCopied();
      }
    });

    /* ── Auto-load reading from shared URL ── */
    (function() {
      var parsed = decodeCosmicParam();
      if (!parsed) return;
      var mInput = form.querySelector('[data-sc-month]');
      var dInput = form.querySelector('[data-sc-day]');
      var yInput = form.querySelector('[data-sc-year]');
      if (!mInput || !dInput || !yInput) return;
      mInput.value = parsed.m;
      dInput.value = parsed.d;
      yInput.value = parsed.y;
      isRecipient = true;
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    })();
  });

  /* Clipboard fallback for older browsers */
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.focus(); ta.select();
    try { document.execCommand('copy'); } catch(e) {}
    document.body.removeChild(ta);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lh-gg-unbox"] && !Shopify.designMode) return;
  try {
    
(function() {
  // Monogram toggle
  document.querySelectorAll('.lh-gg-unbox__mono-row').forEach(function(row) {
    row.querySelectorAll('.lh-gg-unbox__mono-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        row.querySelectorAll('.lh-gg-unbox__mono-btn').forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
